import { render } from "./CMSDetail.vue?vue&type=template&id=2908952a&ts=true"
import script from "./CMSDetail.vue?vue&type=script&lang=ts"
export * from "./CMSDetail.vue?vue&type=script&lang=ts"

import "./CMSDetail.vue?vue&type=style&index=0&id=2908952a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__